import { render, staticRenderFns } from "./CheckinConfig.vue?vue&type=template&id=24f61b1d&scoped=true"
import script from "./CheckinConfig.vue?vue&type=script&lang=js"
export * from "./CheckinConfig.vue?vue&type=script&lang=js"
import style0 from "./CheckinConfig.vue?vue&type=style&index=0&id=24f61b1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f61b1d",
  null
  
)

export default component.exports